export default __webpack_public_path__ + "static/media/avatarnuevo.abb27e48.png";